import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

/**
 * The header of an ancillary+ancillary (non-seat) bundle selection view: the combo image, its name and
 * description, and the combo-offer badge. Purely presentational.
 */
@Component({
  selector: 'fin-bundle-info-header',
  templateUrl: './bundle-info-header.component.html',
  styleUrls: ['./bundle-info-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BundleInfoHeaderComponent {
  /** Combo name, e.g. "Lounge + Priority combo". */
  @Input() bundleName: string | null = null;
  /** Combo description as HTML. */
  @Input() bundleDescription: string | null = null;

  readonly SvgLibraryIcon = SvgLibraryIcon;
}
